import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { fmtDate, hasRole, NOSTROMO_ROLE } from "../lib/roles";
import { Field, ImagesInput, PageHeader, Panel } from "../components/common";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { usePerm } from "../context/PermContext";
import { isMobileSettore } from "../lib/settori";

export default function ShiftReport() {
  const { user } = useAuth();
  const [sp] = useSearchParams();
  const id = sp.get("id");
  const { mySettori } = usePerm();
  const web = id ? sp.get("src") === "web" : !mySettori.some(isMobileSettore);
  const base = web ? "/web/shift-reports" : "/shift-reports";
  const nav = useNavigate();
  const nostromo = hasRole(user, [NOSTROMO_ROLE]);
  const [svolte, setSvolte] = useState("");
  const [prossimo, setProssimo] = useState("");
  const [immagini, setImmagini] = useState([]);
  const [pending, setPending] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      api(`${base}/mine`).then((d) => {
        const r = (d.reports || []).find((x) => x.id === id);
        if (r) { let im = r.immagini; if (typeof im === "string") { try { im = JSON.parse(im); } catch { im = []; } } setSvolte(r.attivita_svolte || ""); setProssimo(r.attivita_da_svolgere || ""); setImmagini(im?.length ? im : r.immagine ? [r.immagine] : []); }
      }).catch(() => {});
    } else if (!web) {
      api("/shift-reports/pending").then((d) => setPending(d.missing || null)).catch(() => {});
    }
  }, [id, base, web]);

  const submit = async () => {
    if (!svolte.trim()) return toast.error(`Compila il campo "${nostromo ? "Attività svolte" : "Attività effettuate"}"`);
    setLoading(true);
    try {
      if (id) { await api(`${base}/${id}`, { method: "PUT", body: { attivita_svolte: svolte, attivita_da_svolgere: prossimo, immagini } }); toast.success("Report aggiornato"); }
      else { await api(base, { method: "POST", body: { attivita_svolte: svolte, attivita_da_svolgere: prossimo, immagini, data: pending?.data } }); toast.success(pending ? "Report mancante compilato" : "Report inviato e registrato"); }
      nav("/report/mine");
    } catch (e) { toast.error(e.message); } finally { setLoading(false); }
  };

  return (
    <div className="max-w-2xl">
      <PageHeader subtitle="Report" title={id ? "Modifica report" : nostromo ? "Report giornaliero" : "Report di fine turno"} />
      <Panel className="space-y-5">
        <p className="text-sm text-slate-500">{id ? "Aggiorna i dettagli del report inviato." : "Il report può essere inviato da uno qualsiasi dei dipendenti in turno oggi."}</p>
        {pending && !id && <div className="rounded-xl bg-amber-50 text-amber-800 p-4 text-sm" data-testid="pending-report-banner">Stai compilando il <b>report mancante</b>{pending.turno ? ` del turno ${pending.turno}` : ""} del {fmtDate(pending.data)}</div>}
        <Field label={nostromo ? "Attività svolte" : "Attività effettuate"}><Textarea rows={6} value={svolte} onChange={(e) => setSvolte(e.target.value)} data-testid="shift-report-done-input" /></Field>
        <Field label={nostromo ? "Attività da svolgere" : "Attività per turno successivo"}><Textarea rows={4} value={prossimo} onChange={(e) => setProssimo(e.target.value)} placeholder="Indicazioni per il prossimo turno..." data-testid="shift-report-next-input" /></Field>
        <Field label="Immagini (max 3, compresse automaticamente)"><ImagesInput value={immagini} onChange={setImmagini} max={3} testid="shift-report-images" /></Field>
        <Button onClick={submit} disabled={loading} className="rounded-full bg-[var(--teal)] px-8" data-testid="shift-report-submit-button">{id ? "Salva modifiche" : "Invia Report"}</Button>
      </Panel>
    </div>
  );
}
